import { render, staticRenderFns } from "./FaireDon.vue?vue&type=template&id=80583204&scoped=true&"
import script from "./FaireDon.vue?vue&type=script&lang=js&"
export * from "./FaireDon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80583204",
  null
  
)

export default component.exports